import { fetchMakeV2, fetchModelV2, fetchVariantV2 } from "../../idv/idv";
import { fetchAreaGroupPartnerSales, fetchSource, fetchPolicyPartnerSales } from "../../policy/policy";
import { limitLength, generateYears, headers, showError } from "../../utils/helpers";


document.addEventListener('alpine:init', () => {
    Alpine.data('partnerSales', () => ({
        isLoading: false,
        selectedYear: new Date().getFullYear(),
        selectedMake: "",
        selectedMakeId: null,
        selectedModel: "",
        selectedModelId: null,
        selectedVariant: "",
        selectedVariantId: null,
        selectedArea: null,
        makeData: null,
        modelData: null,
        variantData: null,
        areaData: null,
        search: '',
        showSearchData: false,
        enteredEmail: "",
        enteredPhone: "",
        enteredCompanyName: "",
        enteredFirstName: "",
        enteredLastName: "",
        enteredVehiclePlateNumberOne: "",
        enteredVehiclePlateNumberTwo: "",
        enteredVehiclePlateNumberThree: "",
        enteredVehicleExpiryOne: "",
        enteredVehicleExpiryTwo: "",
        currentYear: 0,
        years: [],
        policyType: "total_loss_only",
        selectedGender: "",
        frequentAreas: null,
        sourceData: null,
        selectedSourceId: null,
        selectedSource: null,
        createUser: false,
        isAutomaticNotify:false,
        couponCode:null,
        signUp : null,
        userName: null,
        secondaryEmail: null,
        companyName: null,
        campaign: null,
        utmSource: null,
        phoneNumber:null,
        isSubmitLoaderVisible:null,
        isPhoneNumberErrorMessageVisible: false,
        isPhoneNumberPopupActive: false,
        campaignType: null,
        focusOutData:{make:null,model:null},
        validationError:{
            make:false,
            model:false,
            variant:false,
            areaCode:false
        },
        notice: {
            show: false,
            type: '',
            text: ''
        },
        showError,

        init() {
            this.fetchArea('');
            if(!this.product && !this.maxYears){
                this.fetchPolicy();
            }else{
                this.years = this.generateYears(this.maxYears, this.selectedYear)
            } 
            this.couponCode = this.getParam('referralCode');
            this.utmSource = this.getParam('utm_source');
            this.signUp = this.getParam('signup');
            this.userName =  this.getParam('username');
            this.secondaryEmail =this.getParam('secondary_email');
            this.companyName = this.getParam('company_name');
            this.campaign = this.getParam('campaign');
            this.campaignType = this.getParam('campaign_type');
            
        },


        limitLength: limitLength,
        generateYears: generateYears,
        fetchPolicy: fetchPolicyPartnerSales,
        fetchMake: fetchMakeV2,
        fetchModel: fetchModelV2,
        fetchVariant: fetchVariantV2,
        fetchArea: fetchAreaGroupPartnerSales,
        fetchSource: fetchSource,

        updateUserInfo: async function () {
            if (this.campaignType !== 'UCMP') {
                return;
            }
            if(this.signUp === '0'){
                return;
            }
            this.isLoading = true;
            try {
                const response = await fetch('/api/v1/user/0/', {
                  method: 'PATCH',
                  headers: headers,
                  body: JSON.stringify({
                    first_name: this.userName,
                    secondary_email: this.secondaryEmail,
                    company_name: this.companyName,
                    marketing_campaign: this.campaign
                  })
                });
                const data = await response.json();
                if (data?.success === false) {
                    this.showError(data.error)
                    this.isLoading = false;
                  return
                }
      
              } catch (error) {
                console.error('Error Updating User info', error);
              } finally {
                this.isLoading = false;
              }
        },
        onPhoneChange(event) {
            event.target.value = event.target.value.replace(/\D/g, "");
            if(event.target.value.length > 12){
                event.target.value = event.target.value.slice(0, 12)
                this.phoneNumber = event.target.value
            }
        },

        onSubmitClicked(){
            if(!this.isValidPhoneNumber(this.phoneNumber)){
                this.getErrorMessage()
            }else{
                this.getQuote(true)
            }
        },

        getErrorMessage() {
            if (window.lang == 'en') {
                this.showError('The phone number entered is not valid.')
            } else {
                this.showError('Nomor telepon yang dimasukkan tidak benar.')
            }
        },

        isValidPhoneNumber(phoneNumber) {
            return (phoneNumber.length >=9 && phoneNumber.length <= 12);
        },

        validateQuoteForm(){
            if(!this.selectedMakeId){
                this.validationError.make = true;
            }else if(!this.selectedModelId){
                this.validationError.model =  true
            }else if(!this.selectedVariantId){
                this.validationError.variant = true
            }else if(!this.selectedArea){
                this.validationError.areaCode = true;
            }else{
                const leadCapturePopup = document.getElementById('leadCapturePopup')
                if(JSON.parse(window.is_authenticated.toLowerCase()) || !leadCapturePopup){
                    this.getQuote(false)
                }else{
                    this.isPhoneNumberPopupActive=true;
                }
            }
        },
       
        // Create Quote for Users

        getQuote:function(isLeadCapturePopupEnabled = false){
            if(isLeadCapturePopupEnabled){
                dataLayer.push({'event': 'submitVehicleDetailsWithLeadCapture',  vehicleBrand: this.selectedMake,vehicleModel:this.selectedModel,vehicleType: this.selectedVariant,modelYear: this.selectedYear,areaCode: this.selectedArea,leadCapturePhoneNumber:this.phoneNumber });
            }else{
                dataLayer.push({'event': 'submitVehicleDetails',  vehicleBrand: this.selectedMake,vehicleModel:this.selectedModel,vehicleType: this.selectedVariant,modelYear: this.selectedYear,areaCode: this.selectedArea });
            }
            let body = {
                production_year: this.selectedYear,
                vehicle_variant: this.selectedVariantId,
                area_group: this.selectedArea,
                coupon:this.couponCode,
            }

            if(this.phoneNumber){
                body = {...body,phone:this.phoneNumber}
            }

            if(this.product){
                body = {...body,product:this.product}
              }

            if(this.utmSource){
                body = {...body,utm_source:this.utmSource}
            }
           
            this.isLoading = true;
            this.isSubmitLoaderVisible = true;
            fetch(`/api/v2/quote/`, {
                method: "POST",
                body: JSON.stringify(body),
                headers: headers
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data?.success === false) {
                        this.showError(data.error)
                        this.isLoading = false;
                        return
                    }
                    this.isLoading = false;
                    this.isPhoneNumberPopupActive = false;
                    localStorage.setItem(data.data.snowflake, JSON.stringify(this.couponCode))

                    setTimeout(() => {
                        window.location.href = `${window.quotePreview}?quote_id=${data.data.snowflake}`
                      }, 300)   
                }).catch(error => console.error('Error creating Quote', error))
                .finally(() => {
                    this.isSubmitLoaderVisible = false
                });
        },

       getParam:function(param){
        return new URLSearchParams(window.location.search).get(param);
       },

        // Create Quote for Partner Sale
        createQuote: function (buttonClicked) {

            if (this.enteredPhone && this.enteredPhone.startsWith('62')){
                 this.showError(document.getElementById("partnerSales").dataset.errorphonenumber);
                 return
              }
            body = {
                production_year: this.selectedYear,
                vehicle_variant: this.selectedVariantId,
                area_group: this.selectedArea,
                phone: this.enteredPhone,
                email: this.enteredEmail,
                product: this.product,
                source: this.selectedSourceId,
                create_user: this.createUser,
                is_notified:this.isAutomaticNotify,
                slip: {
                    stnk_nomor_registrasi: `${this.enteredVehiclePlateNumberOne} ${this.enteredVehiclePlateNumberTwo} ${this.enteredVehiclePlateNumberThree}`,
                    stnk_nomor_masa_berlaku: this.enteredVehicleExpiry,
                },
                additional_info: {
                    first_name: this.enteredFirstName,
                    last_name: this.enteredLastName,
                }
            }
            this.isLoading = true
            fetch(`/api/v2/partner-quote/`, {
                method: "POST",
                body: JSON.stringify(body),
                headers: headers
            })
                .then((res) => res.json())
                .then(async (data) => {
                    if (data?.success === false) {
                        this.showError(data.error)
                        return
                    }
                    
                    if(this.enteredPhone && this.isAutomaticNotify){
                      const result = await this.onCreateQuote(data)
                    }
                     
                     if (buttonClicked === 'PDF') {
                        let downloadLink = document.createElement('a');
                        downloadLink.download = `${data.data.snowflake}.pdf`;
                        downloadLink.href = `${window.quotePDFURL}?quote=${data.data.snowflake}`;
                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                        document.body.removeChild(downloadLink);
                    } else if (buttonClicked === 'QR') {
                        setTimeout(() => {
                            window.location.href = `${window.quoteQRCodeURL}?quote_id=${data.data.snowflake}`;
                        }, 500);
                    } else {
                        setTimeout(() => {
                            window.location.href = `${window.editQuoteURL}?quote_id=${data.data.snowflake}`;
                        }, 500);
                    }
                    
                }).catch(error => console.error('Error creating Quote', error));
                          this.isLoading = false  
        },
        async onCreateQuote(data){
        this.isLoading = true
          await fetch(`/api/v1/notify-user/`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                phone: this.enteredPhone,
                snowflake: data.data.snowflake,
                whatsapp_template_type: "PRTS"
            })
        })
        .then(res => res.json())
        .then(data => {
            if (data?.success === false) {
                this.showError(data.error);
            }
        })
        .catch(err => {
            console.error("Notification API failed:", err);
            this.showError("Notification failed.");
        });
                    this.isLoading = false
    
        },

        isFormInvalid: function () {
            return [this.selectedYear, this.selectedMake, this.selectedModel, this.selectedVariant, this.selectedArea, this.selectedSourceId,
            this.enteredVehicleExpiryOne.trim(), this.enteredVehicleExpiryTwo.trim(), this.enteredVehiclePlateNumberOne.trim(), this.enteredVehiclePlateNumberTwo.trim(),
            this.enteredVehiclePlateNumberThree.trim()].some(value => !value)
        },
    }))
})
